/**
 * Created by pandemio on 4/12/19.
 */
/**
 * Created by pandemio on 4/12/19.
 */
import React from 'react';
import {Card, Col, Container, Row, Button, Table} from 'reactstrap';
import {Link} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUsers } from '@fortawesome/free-solid-svg-icons';
import ApiCalls from '../../custom-classes/api-calls';
import PieChart from '../charts/chart-pie-full';
import DatePicker from '../date-picker/date-picker-recent';
import UsersDataTable from '../datatables/users-data-table';
import Settings from '../../custom-classes/settings';

/**
 * Report to read the usage by client
 */
class ReportUsage extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            languages: languages,
            userDetails: '',
            fromDate: null,
            toDate: null,
            userId: null,
            activeSubscription: null,
            profileQuantity: null,
            profilesActive: null,
            profilesNonActive: null,
            rows: null,
            chartData: null
        };
        this.props.addTranslation(global);

        this.handleClientSelected = this.handleClientSelected.bind(this);
        this.handleSelectedFromDate = this.handleSelectedFromDate.bind(this);
        this.handleSelectedToDate = this.handleSelectedToDate.bind(this);
        this.showUserBox = this.showUserBox.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    showUserBox(){
        this.setState({
            userId: null
        })
    }

    handleClientSelected(e){
        this.setState({
            userDetails: e.GivenName + ' ' + e.Surname + ' (' + e.Username + ')',
            userId: e.UserId
        },()=>{
            this.getData();
        });
    }

    handleSelectedFromDate(e){
        this.setState({
            fromDate: e.date
        },()=>{
            this.getData();
        });
    }

    handleSelectedToDate(e){
        this.setState({
            toDate: e.date
        },()=>{
            this.getData();
        });
    }

    getData(){
        let apiCall =
            ApiCalls.getReportUsage(this.state.userId,
                this.state.fromDate, this.state.toDate);
        apiCall.then((data)=> {
            this.createTableData(data);
            this.setState({
                activeSubscription: data.ActiveSubscription
            });

            let dataChart = [{
                value: data.ProfilesActive,
                color:"#dcf441",
                highlight: "#dcf441",
                label: LanguageManager.getTranslation("reports.quantity-active", this.state.languages)
            }, {
                value:  data.ProfilesNonActive,
                color: "#f4416b",
                highlight: "#f4416b",
                label: LanguageManager.getTranslation("reports.quantity-non-active", this.state.languages)
            }];

            this.setState({chartData:dataChart});
        });
    }

    createTableData(data){
        let rows = [];
        let row =
            <tr key={0}>
                <td>{data.ProfilesQuantity}</td>
                <td>{data.ProfilesActive}</td>
                <td>{data.ProfilesNonActive}</td>
            </tr>;
        rows.push(row);
        this.setState({rows:rows});
    }

    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faUsers}/>{' '}
                            <Translate id="reports.use" options={{renderInnerHtml: true}}/>
                        </h2>
                        <small className="white-text">
                            <Translate id="reports.use-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <h5>I. <Translate id="reports.select-client" options={{renderInnerHtml: false}}/></h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            this.state.userId === null || this.state.userId === '' ?
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <UsersDataTable roleId={Settings.CLIENT_ROLE_ID} updateParent={this.handleClientSelected}/>
                                        </Col> : null
                                        }
                                    </Row>
                                    <Row>
                                        {
                                            this.state.userId !== null && this.state.userId !== '' ?
                                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                <Translate id="reports.selected-client"
                                                           options={{renderInnerHtml: false}}/>
                                                : <span className="yellow-text"><b> {this.state.userDetails} </b></span> {' '}

                                                <Button color="warning" onClick={this.showUserBox}>
                                                    <Translate id="reports.select-a-client"
                                                               options={{renderInnerHtml: false}}/>
                                                </Button>
                                            </Col> : null
                                        }
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-blue-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <h5>II. <Translate id="reports.filter-date-profile-activity"
                                                           options={{renderInnerHtml: false}}/></h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 12}}>
                                            <Translate id="reports.date-from" options={{renderInnerHtml: false}}/>
                                            <DatePicker updateParent={this.handleSelectedFromDate} />
                                        </Col>
                                        <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 12}}>
                                            <Translate id="reports.date-to" options={{renderInnerHtml: false}}/>
                                            <DatePicker updateParent={this.handleSelectedToDate} />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                {
                                    this.state.userId !== null && this.state.userId !== '' ?
                                <Card body className="card-darker-transparency">
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <h5><Translate id="reports.details"
                                                               options={{renderInnerHtml: false}}/></h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                            <Translate id="reports.has-active-subscription" options={{renderInnerHtml: false}}/>
                                            {' '}
                                            {this.state.activeSubscription ?
                                                <span className="yellow-text"><b><Translate id="reports.yes"
                                                options={{renderInnerHtml: false}}/></b></span>:
                                                <span className="yellow-text"><b><Translate id="reports.no"
                                                           options={{renderInnerHtml: false}}/></b></span>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size:12}}>
                                            <Table className="card-darker-transparency" responsive>
                                                <thead>
                                                <tr>
                                                    <th><Translate id="reports.profiles-quantity" options={{renderInnerHtml: false}}/></th>
                                                    <th><Translate id="reports.quantity-active" options={{renderInnerHtml: false}}/></th>
                                                    <th><Translate id="reports.quantity-non-active" options={{renderInnerHtml: false}}/></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                { this.state.rows !== "0" ? this.state.rows : null }
                                                </tbody>
                                            </Table>
                                        </Col>
                                            {this.state.chartData !== null ?
                                                <Col lg={{size:6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                                    <PieChart chartData={this.state.chartData}/>
                                                </Col> : null
                                            }
                                    </Row>
                                </Card> : null
                                }
                            </Col>
                        </Row>

                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(ReportUsage);